"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleTrailBarChartLabel = exports.CircleTrailBarChartLabelSizes = exports.CircleTrailBarChartLabelSizesBase = exports.CircleTrailBarChartLabelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('circle-trail-bar-chart-label');
exports.CircleTrailBarChartLabelDefaultProps = {};
exports.CircleTrailBarChartLabelSizesBase = {
  small: '0.9em',
  default: '0.9em',
  large: '1em'
};
exports.CircleTrailBarChartLabelSizes = {
  small: '0.9em',
  default: '1.25em',
  large: '1.45em'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 400;\n    word-break: break-word;\n    padding-right: ", ";\n    ", "\n\n    ", "\n\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "], ["\n    font-weight: 400;\n    word-break: break-word;\n    padding-right: ", ";\n    ", "\n\n    ", "\n\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "])), theme_1.theme.UNIT(4), function (_a) {
    var item = _a.item;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n      font-family: ", ";\n    "], ["\n      font-size: ", ";\n      font-family: ", ";\n    "])), item.labelSize || exports.CircleTrailBarChartLabelSizesBase[item.size || 'default'], theme_1.theme.FONT(item.labelFont || 'sans'));
  }, function (_a) {
    var clickable = _a.clickable;
    return clickable && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    word-break: none;\n    ", "\n\n  "], ["\n    word-break: none;\n    ", "\n\n  "])), function (_a) {
    var item = _a.item;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), item.labelSize || exports.CircleTrailBarChartLabelSizes[item.size || 'default']);
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var CircleTrailBarChartLabel = function (props) {
  var className = props.className,
    item = props.item,
    onClick = props.onClick;
  if (!item) {
    return null;
  }
  var clickable = !!(onClick || item.onCircleClick);
  return react_1.default.createElement(My.Container, {
    clickable: clickable,
    onClick: item.onLabelClick || onClick,
    title: item.label,
    item: item,
    className: cls.name(className)
  }, item.label);
};
exports.CircleTrailBarChartLabel = CircleTrailBarChartLabel;
exports.CircleTrailBarChartLabel.defaultProps = exports.CircleTrailBarChartLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;